










import { Component, Vue, Watch } from "vue-property-decorator";
@Component
export default class Step extends Vue {
    public data() {
        return {
            step: "",
        };
    }

    public created() {
        this.$data.step = JSON.parse(this.$router.currentRoute.params.step);
    }

    @Watch("$route")
    public routechange(to: any, from: any) {
        this.$data.step = JSON.parse(this.$router.currentRoute.params.step);
    }
}
